import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import { Panel } from "primereact/panel";
import { memo } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useReport } from "../../context/report";
import { Button } from "primereact/button";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { ListaDefeitosDialog } from "../Dialogs/ListaDefeitosDialog";

export default memo(function GraficoDefeitos({ data, title }) {
  const { handlePrint, printing } = useReport();
  const [type, setType] = useState("colaborador");
  const [xLabel, setXLabel] = useState('');
  
  const [orderDefeitos, setOrderDefeitos] = useState("desc");

  const [printingAll, setPrintingAll] = useState(false);

  const TITLES_BASED_ON_TYPE = {
    artigo: "GRÁFICO DE METRAGEM DE DEFEITOS POR ARTIGO",
    colaborador: "GRÁFICO DE METRAGEM DE DEFEITOS POR COLABORADOR",
    tear: "GRÁFICO DE METRAGEM DE DEFEITOS POR TEAR",
  };

  const componentRef = useRef();

  const handlePrintAll = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPrintingAll(true);
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
    onAfterPrint: () => {
      setPrintingAll(false);
    }
  });

  if (data === null) {
    return null;
  }

  const handleChangeType = () => {
    if (type === "artigo") {
      setType("colaborador");
    } else if (type === "colaborador") {
      setType("tear");
    } else if (type === "tear") {
      setType("artigo");
    }
  };

  const handleToggleOrderDefeitos = () => {
    setOrderDefeitos((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const chartDataDefeitos = (() => {
    if (!data?.defeitos?.labels || !data?.defeitos?.datasets) return data.defeitos;
    
    const labels = [...data.defeitos.labels];
    const datasetData = [...data.defeitos.datasets[0].data];
    
    const combined = labels.map((label, index) => ({
      label,
      value: datasetData[index]
    })).sort((a, b) => {
      if (orderDefeitos === "asc") {
        return a.value - b.value;
      } else {
        return b.value - a.value;
      }
    });

    return {
      ...data.defeitos,
      labels: combined.map(item => item.label),
      datasets: [
        {
          ...data.defeitos.datasets[0],
          data: combined.map(item => item.value)
        }
      ]
    };
  })();

  const DefeitosColaborador = () => {
    const [order, setOrder] = useState("asc");

    const handleChangeOrder = () => {
      if (order === "asc") {
        setOrder("desc");
      } else if (order === "desc") {
        setOrder("asc");
      }
    };

    let values = [...data.dados];
    let array = [];

    values.forEach((element) => {
      let index = array.findIndex((item) => {
        return item.label === element[type];
      });
      if (index === -1) {
        array.push({
          label: element[type],
          metragem: 0,
        });
      }
    });

    let total = 0;

    array.forEach((element) => {
      let metragem = 0;
      let filtered = values.filter((element1) => {
        return element1[type] === element.label;
      });

      filtered.forEach((element) => {
        metragem += parseFloat(element.metragem);
      });

      total += metragem;
      element.metragem = metragem;
    });


    array = array.sort((a, b) => {
      return a["metragem"] - b["metragem"];
    });

    if (order === "desc") {
      array = array.reverse();
    }

    if (type === 'tear') {
      let copyArray = [];
      let pareto = 0;
      let pos = 0;

      array = array.sort((a, b) => {
        return a["metragem"] - b["metragem"];
      }).reverse();

      while (pareto / total * 100 < 80) {
        copyArray.push(array[pos]);
        pareto += array[pos].metragem;
        pos += 1;
      }

      array = [...copyArray];
    }

    let labels = [];
    let dataset = [];

    array.forEach((element) => {
      labels.push([
        element.label,
        Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format((element.metragem * 100) / total) +
        "%",
      ]);
      dataset.push(parseInt(element.metragem));
    });

    const chartData = {
      labels: labels,
      datasets: [
        {
          label: "Metragem",
          data: dataset,
          backgroundColor: "#3498db",
        },
      ],
    };

    return (
      <>
        <div className="p-flex p-flex-row p-jc-start p-ai-start">
          <Button
            className="p-m-2"
            icon="pi pi-print"
            onClick={() => handlePrint("graficoMetragemTipo")}
          />
          <Button
            className="p-m-2 p-button-danger"
            icon="pi pi-refresh"
            onClick={() => handleChangeOrder()}
          />

          <Button
            className="p-m-2 p-button-success"
            icon="pi pi-chevron-circle-right"
            onClick={() => handleChangeType()}
          />
        </div>

        <Chart
          id="graficoMetragemTipo"
          data={chartData}
          height={printing ? "210mm" : "450px"}
          width={printing ? "297mm" : "100%"}
          options={{
            maintainAspectRatio: false,
            layout: {
              padding: 20,
            },
            plugins: {
              datalabels: {
                anchor: "end",
                align: "end",
                formatter: (value) => {
                  return Intl.NumberFormat("pt-BR", {
                    maximumFractionDigits: 2,
                  }).format(value);
                },
                font: {
                  size: 24,
                },
                color: "#2c3e50",
              },
              title: {
                display: true,
                text: TITLES_BASED_ON_TYPE[type] + " - " + title,
                font: {
                  size: 20,
                },
              },
              subtitle: {
                display: true,
                text:
                  "Total: " + Intl.NumberFormat("pt-BR").format(total) + "m",
                font: {
                  size: 20,
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  font: {
                    size: 16,
                  },
                  color: "#000",
                },
              },
            },
          }}
          plugins={[ChartDataLabels]}
          type="bar"
        />
      </>
    );
  };

  return (
    <div
      style={{
        opacity: printing ? "0.01" : "",
      }}
    >
      <Panel header="GRÁFICO DE DEFEITOS POR TURMA" toggleable collapsed={true}>
        <div className="p-grid">
          <div className="p-col-12">
            <Button
              className="p-m-1"
              icon="pi pi-print"
              onClick={handlePrintAll}
            />
          </div>
        </div>
        <div className="p-grid" ref={componentRef}>
          {data.chart.map((element, index) => (
            <Card
              header={() => (
                <div style={{ backgroundColor: element.color }}>
                  <h2 style={{ color: "#FFF", padding: printingAll ? 8 : 20 }}>
                    {element.title}
                  </h2>
                </div>
              )}
              key={index}
              className={"p-elevation-8 " + (printingAll ? "p-col-6" : "p-col-6 p-mb-6")}
            >

              {printingAll === false && (
                <Button
                  className="p-m-2"
                  icon="pi pi-print"
                  onClick={() => handlePrint(`mappedChart${index}`)}
                />
              )}

              <Chart
                id={`mappedChart${index}`}
                data={element.values}
                key={`mappedChart${index}`}
                height={printing ? "210mm" : printingAll ? "200px" : "350px"}
                width={printing ? "297mm" : printingAll ? "400px" : "100%"}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    datalabels: {
                      labels: {
                        porcentagem: {
                          formatter: (value) => {
                            if (value === 0) {
                              return "";
                            }
                            return (
                              Intl.NumberFormat("pt-BR", {
                                maximumFractionDigits: 2,
                              }).format(value) + "%"
                            );
                          },
                        },
                        valor: {
                          align: "end",
                          anchor: "end",
                          formatter: (value) => {
                            if (value === 0) {
                              return "";
                            }
                            return (
                              Intl.NumberFormat("pt-BR", {
                                maximumFractionDigits: 2,
                              }).format(
                                (value / 100) * parseFloat(data.turmas[index])
                              ) + "m"
                            );
                          },
                          color: "#2c3e50",
                        },
                      },
                      font: {
                        size: printingAll ? 16 : 20,
                      },
                      color: "#000",
                    },
                    title: {
                      display: true,
                      text: "Gráfico de Defeitos por Grupo - " + title,
                      font: {
                        size: printingAll ? 14 : 20,
                      },
                    },
                    subtitle: {
                      display: true,
                      text: "Total: " + (data.turmas[index] || 0) + "m",
                      font: {
                        size: 20,
                      },
                    },
                  },
                  scales: {
                    x: {
                      ticks: {
                        font: {
                          size: printingAll ? 6 : 16,
                          weight: 'bold'
                        },
                        color: "#000",
                      },
                    },
                  },
                }}
                plugins={[ChartDataLabels]}
                type="bar"
              />
            </Card>
          ))}
        </div>

        <div className="p-grid">
          <div className="p-col-12">
            <Card className="p-elevation-8">

              <Button
                className="p-m-2"
                icon="pi pi-print"
                onClick={() => handlePrint("graficoTotalDefeitosTurma")}
              />

              <Chart
                id="graficoTotalDefeitosTurma"
                data={{
                  labels: ["Total"],
                  datasets: data.chart.map((element, index) => ({
                    label: element.title,
                    data: [parseFloat(data.turmas[index]) || 0],
                    backgroundColor: element.color,
                  })),
                }}
                height={printing ? "210mm" : "450px"}
                width={printing ? "297mm" : "100%"}
                plugins={[ChartDataLabels]}
                options={{
                  maintainAspectRatio: false,
                  layout: {
                    padding: 20,
                  },
                  plugins: {
                    legend: {
                      display: true,
                    },
                    datalabels: {
                      anchor: "end",
                      align: "end",
                      formatter: (value) => {
                        if (value === 0) {
                          return "";
                        }

                        return (
                          Intl.NumberFormat("pt-BR", {
                            maximumFractionDigits: 2,
                          }).format(value) + "m"
                        );
                      },
                      font: {
                        size: 20,
                      },
                      color: "#2c3e50",
                    },
                    title: {
                      display: true,
                      text: "GRÁFICO DE METRAGEM DE DEFEITOS POR TURMA - " + title,
                      font: {
                        size: 20,
                      },
                    },
                  },
                  scales: {
                    x: {
                      ticks: {
                        font: {
                          size: 16,
                          weight: "bold",
                        },
                        color: "#000",
                      },
                    },
                    y: {
                      ticks: {
                        callback: (value) => {
                          return (
                            Intl.NumberFormat("pt-BR", {
                              maximumFractionDigits: 0,
                            }).format(value) + "m"
                          );
                        },
                        font: {
                          size: 14,
                        },
                        color: "#000",
                      },
                    },
                  },
                }}
                type="bar"
              />

            </Card>
          </div>
        </div>

        <div className="p-grid">
          <div className="p-col-12">
            <Card className="p-elevation-8">

              <Button
                className="p-m-2"
                icon="pi pi-print"
                onClick={() => handlePrint("graficoTurmaGeral")}
              />

              <Chart
                id="graficoTurmaGeral"
                data={data.pie}
                height={printing ? "210mm" : "400px"}
                width={printing ? "297mm" : "100%"}
                plugins={[ChartDataLabels]}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    datalabels: {
                      formatter: (value) => {
                        return (
                          Intl.NumberFormat("pt-BR", {
                            maximumFractionDigits: 0,
                          }).format(value) + "%"
                        );
                      },
                      font: {
                        size: 18,
                      },
                      color: "#000000",
                    },
                    title: {
                      display: true,
                      text:
                        "GRÁFICO - PERCENTUAL DE DEFEITOS POR TURMA - " + title,
                      font: {
                        size: 18,
                      },
                    },
                  },
                }}
                type="pie"
              />

            </Card>
          </div>
        </div>
      </Panel>

      <Panel
        header={TITLES_BASED_ON_TYPE[type] + " - " + title}
        toggleable
        collapsed={true}
      >
        <div className="p-flex p-flex-row p-jc-start p-ai-start">
          <Button
            className="p-m-2"
            icon="pi pi-print"
            onClick={() => handlePrint("graficoDefeitos2")}
          />
          <Button
            className="p-m-2 p-button-danger"
            icon="pi pi-refresh"
            onClick={handleToggleOrderDefeitos}
            title="Alternar Ordem (Crescente/Decrescente)"
          />
        </div>

        <Chart
          id="graficoDefeitos2"
          data={chartDataDefeitos}
          height={printing ? "210mm" : "450px"}
          width={printing ? "297mm" : "100%"}
          options={{
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                align: "end",
                anchor: "end",
                formatter: (value) => {
                  return (
                    Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 2,
                    }).format(value) + "m"
                  );
                },
                font: {
                  size: 24,
                },
                color: "#2c3e50",
              },
              title: {
                display: true,
                text: "Metragem por Tipo de Defeito - " + title,
                font: {
                  size: 24,
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  font: {
                    size: 16,
                  },
                  color: "#000",
                },
              },
            },
          }}
          plugins={[ChartDataLabels]}
          type="bar"
        />

        <Chart
          id="graficoDefeitos2"
          data={data.pareto}
          height={printing ? "210mm" : "450px"}
          width={printing ? "297mm" : "100%"}
          options={{
            maintainAspectRatio: false,
            onClick: (e) => {
              let value = e.chart.scales.x.getValueForPixel(e.x);
              let label = e.chart.data.labels[value];
              setXLabel(label);
            },
            plugins: {
              datalabels: {
                align: "end",
                anchor: "end",
                formatter: (value) => {
                  return (
                    Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 2,
                    }).format(value) + "m"
                  );
                },
                font: {
                  size: 24,
                },
                color: "#2c3e50",
              },
              title: {
                display: true,
                text: "Metragem por Tipo de Defeito Pareto - " + title,
                font: {
                  size: 24,
                },
              },
            },
          }}
          plugins={[ChartDataLabels]}
          type="bar"
        />
        <DefeitosColaborador />
      </Panel>

      <ListaDefeitosDialog 
        xLabel={xLabel}
        setXLabel={setXLabel}
        data={data}
      />
    </div>
  );
});